export default __webpack_public_path__ + "static/lesson-de@2x-394e3a4422d2bebc5087ecfc2c998b04.png";